<template>
    <div>
                   <window v-if="visible" :title="'GSAI'" @close="toggleDialog" :initial-height="700" :initial-width="1000">
                    <iframe sandbox="allow-scripts allow-popups allow-modals allow-forms allow-downloads allow-same-origin allow-popups-to-escape-sandbox allow-top-navigation allow-top-navigation-by-user-activation" :src="url" style="width: 100%; height:100%" ></iframe>
               </window>
           </div>
   </template>
   <script>
   import { Window } from '@progress/kendo-vue-dialogs';
   import { Button } from '@progress/kendo-vue-buttons';
   import { Input } from '@progress/kendo-vue-inputs';
 
   export default {
    emits: ['toggleAIDialog'],
       components: {
           'window': Window,
         'kbutton': Button,
          'kinput': Input
       },
       props:{
        url:String,
        visible:Boolean
       },
       data: function () {
           return { 
            
           };
       },
       methods: {
           toggleDialog () {
            this.$emit('toggleAIDialog')
           }
       }
   };
   
   </script>
   